module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"departments":"Abteilungen","number":"Nummer","search":"Suche","title":"Bezeichnung"},"en":{"departments":"Departments","number":"Number","search":"Search","title":"Title"}}')
  delete Component.options._Ctor
}
